module.exports = __webpack_public_path__ + "img/17.48585a4d.png";